const HomeEn = {
    one: {
        title: "Elevate Your Digital Journey",
        content: `<strong>Technology designed</strong> for your growth.`,
        about_blue: "About Blueshine",
    },
    two: {
        title: "Reimagining Possibilities, Raising the Bar",
        content: `Where cutting-edge technology meets <span className="description-highlight font-bold text-secondary">unwavering quality</span> — to accelerate your business forward.`,
    }
}

export default HomeEn;